"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class NotifiedRecentlyError extends client_library_1.ExtendableError {
    constructor() {
        super('User was notified too recently');
    }
}
exports.default = NotifiedRecentlyError;
//# sourceMappingURL=NotifiedRecentlyError.js.map